import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@core/services/api.tokens';
import {
  getUrlParamsFromPaginatedRequest,
  PaginatedRequest,
} from '@shared/models/pagination/paginated-request.interface';
import { PaginatedResponse } from '@shared/models/pagination/paginated-response.interface';
import { Tenant } from '@shared/models/tenant.interface';
import { Observable } from 'rxjs';

export interface CreateTenantPayload {
  legal_name: string;
  tva_number: string;
  national_id: string;
  address: string;
  seats_number: number;
  mapping_number: number;
  evaluation_number: number;
  expiration_date: Date;
}

export interface UpdateTenantPayload extends Partial<CreateTenantPayload> {
  is_active?: boolean;
  is_evaluated?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TenantsAdminService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  findAll(request: PaginatedRequest): Observable<PaginatedResponse<Tenant>> {
    return this.http.get<PaginatedResponse<Tenant>>(
      `${this.apiUrl}/tenants${getUrlParamsFromPaginatedRequest(request)}`,
      { withCredentials: true },
    );
  }
  findOne(id: string): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.apiUrl}/tenants/${id}`, { withCredentials: true });
  }

  updateTenant(id: string, payload: UpdateTenantPayload): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.apiUrl}/tenants/${id}`, payload, {
      withCredentials: true,
    });
  }

  createTenant(payload: CreateTenantPayload): Observable<Tenant> {
    return this.http.post<Tenant>(`${this.apiUrl}/tenants`, payload, { withCredentials: true });
  }

  deleteTenant(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/tenants/${id}`, { withCredentials: true });
  }
}
